module.exports = __webpack_public_path__ + "fonts/lato-light-webfont.bd4cbc59.woff2";